var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Button, Icon } from '@digitools/honest-react';
import useTealium from '../../../../hooks/useTealium';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: white;\n  text-transform: uppercase;\n  font-size: 0.875rem;\n  font-weight: bolder;\n  padding: 0.8rem;\n  display: flex;\n\n  &:hover,\n  &:active,\n  &:focus {\n    padding: 0.8rem !important;\n  }\n\n  span {\n    @media (max-width: 767px) {\n      & {\n        display: none;\n      }\n    }\n  }\n"], ["\n  color: white;\n  text-transform: uppercase;\n  font-size: 0.875rem;\n  font-weight: bolder;\n  padding: 0.8rem;\n  display: flex;\n\n  &:hover,\n  &:active,\n  &:focus {\n    padding: 0.8rem !important;\n  }\n\n  span {\n    @media (max-width: 767px) {\n      & {\n        display: none;\n      }\n    }\n  }\n"])));
var StyledPhoneIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 0.5rem;\n  transform: rotateY(180deg);\n"], ["\n  margin-right: 0.5rem;\n  transform: rotateY(180deg);\n"])));
var SupportSlideoutButton = function (_a) {
  var openSlideout = _a.openSlideout;
  var trackEvent = useTealium().trackEvent;
  var onSliderButtonClick = function (openSlideout) {
    openSlideout(true);
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT,
      event_type: TEALIUM_EVENT.EVENT_TYPE.H_LINK,
      event_status: 'Open'
    });
  };
  return _jsxs(StyledButton, __assign({
    onClick: function () {
      return onSliderButtonClick(openSlideout);
    },
    "data-testid": 'slideout-open-button'
  }, {
    children: [_jsx(StyledPhoneIcon, {
      color: 'white',
      name: 'phone',
      "aria-hidden": 'true'
    }), _jsx("span", __assign({
      className: 'contact-support-text'
    }, {
      children: "Contact & Support"
    }))]
  }));
};
export default SupportSlideoutButton;
var templateObject_1, templateObject_2;